import { buildTranslate } from 'locales'
import React from 'react'

const t = buildTranslate('promo_codes.overview.hero.animation')

const Coupon = () => (
  <div className="hero-coupon">
    <div className="hero-coupon__lift-shadow" />
    <div className="hero-coupon__header">{t('merchant')}</div>
    <div className="hero-coupon__body">
      <div className="hero-coupon__offer">{t('offer_headline')}</div>
      <div className="hero-coupon__offer-sub">{t('offer_sub')}</div>
      <span className="hero-coupon__code">{t('promo_code')}</span>
    </div>
  </div>
)

export default Coupon
